import { type ComputedRef, type Ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import {
  type MobileViewMode,
  useMobilePreferenceStore,
} from '@/core/shared/mobile-preference/mobile-preference.store';

interface UseMobilePreferences {
  preferredViewMode: Ref<MobileViewMode>;
  prefersDesktop: ComputedRef<boolean>;
  viewFullVersion: () => void;
}

// There is deliberately no in-app "back to mobile" action: the boot reset
// (useMobileViewModeBootReset) returns phones to the mobile view on the next
// full page load, making "Show full version" a per-session escape hatch.
export function useMobilePreferences(): UseMobilePreferences {
  const store = useMobilePreferenceStore();
  const { preferredViewMode } = storeToRefs(store);

  return {
    preferredViewMode,
    prefersDesktop: computed(() => preferredViewMode.value === 'desktop'),
    viewFullVersion: () => store.setPreferredViewMode('desktop'),
  };
}
